import { EMP_STORAGE_KEYS } from "./config";

// =============================================================
// Cầu nối chuyển phiên giữa app Admin và Cổng nhân viên (FEv1).
// Token của 2 bên cùng chuẩn (generateAccessToken), nên có thể
// chuyển qua lại mà không cần đăng nhập lại.
// =============================================================

/**
 * Ghi session nhân viên từ phiên admin hiện tại để chuyển sang /nv
 * mà không phải đăng nhập lại.
 * @param {{ user?: object, accessToken?: string }} adminCurrentUser
 *   = state.auth.login.currentUser của app admin
 * @returns {boolean} true nếu hydrate thành công
 */
export const hydrateEmployeeSessionFromAdmin = (adminCurrentUser) => {
  const accessToken = adminCurrentUser?.accessToken;
  const user = adminCurrentUser?.user;
  if (!accessToken || !user) return false;

  localStorage.setItem(EMP_STORAGE_KEYS.ACCESS_TOKEN, accessToken);
  localStorage.setItem(EMP_STORAGE_KEYS.USER, JSON.stringify(user));
  // Không set REFRESH_TOKEN: BE dùng cookie refreshToken (httpOnly) đã set khi
  // đăng nhập admin để cấp lại access token khi cần.
  return true;
};
